import React from "react";

import { Badge } from "@mui/material";
import { useTranslation } from "react-i18next";

import { User } from "../../../models/user";
import useStyles from "./styles";

interface Props {
  user?: User;
}

export const UserVersion: React.FC<Props> = (props) => {
  const { user } = props;
  const classes = useStyles();
  const { t: translate } = useTranslation();

  return user ? (
    <div>
      <Badge className={classes.headerBadge}>
        {user.status} {translate("user")}
      </Badge>
      <span className={classes.headerVersion} data-cy="company-profile-name">
        {translate("version")} |<strong> {user?.company?.profile?.name || ""}</strong>
      </span>
    </div>
  ) : null;
};
